import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Lock icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Lock } from '@sravni/design-system-icons'
 *
 * <Lock />
 * ```
 */
var Lock = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Lock", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.667 8.333v-2.5a3.333 3.333 0 0 1 6.667 0v2.5M14.167 17.5H5.834c-.921 0-1.667-.746-1.667-1.666V10c0-.92.746-1.666 1.667-1.666h8.333c.92 0 1.667.745 1.667 1.666v5.834c0 .92-.746 1.666-1.667 1.666Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M7.5 12.95c-.002 0-.004.002-.004.005 0 .002.002.004.004.004.003 0 .004-.002.004-.004 0-.003-.001-.004-.004-.004ZM10.004 12.95c-.002 0-.004.002-.004.005 0 .002.002.004.004.004.003 0 .004-.002.004-.004 0-.003-.001-.004-.004-.004ZM12.5 12.95c-.002 0-.004.002-.004.005 0 .002.002.004.004.004.003 0 .004-.002.004-.004 0-.003-.001-.004-.004-.004Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Lock };
//# sourceMappingURL=Lock.js.map
